<template>
  <div>
    <el-dialog
      :visible.sync="show"
      show-cancel-button
      width="450px"
      style="
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.6) 0%,
              rgba(255, 255, 255, 0) 100%
            );
          "
    >
      <div style="margin:20px；width:1200px">
        <div class="headers">
          <p>{{ title }}</p>
        </div>

        <div class="main enterBodys">

          <p v-html="intrdouceInfo">
          </p>
        </div>
        <div class="btnWrap">
          <!-- <div class="nextStepBtn" @click="goFalse">取消</div> -->
          <div
            class="nextStepBtn sureBtn"
            style="
                      width: 200px;
                      height: 40px;
                      background: #0f40b9;
                      border-radius: 4px;
                      margin: 0 auto;
                    "
            @click="goOk"
          >
            我已阅读
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* global http protocol */
export default {
  data() {
    return {
      show: false,
      intrdouceInfo: '',
      title: ''
    }
  },
  mounted() {
    this.getInforDetail(200)
  },
  methods: {
    getInforDetail(id) {
      protocol.param_getContentDetails.param.id = id
      http.getRes(protocol.param_getContentDetails).then(response => {
        const {
          code,
          message,
          value
        } = response.data
        if (code === 0 || code === '0') {
          this.intrdouceInfo = value.content
          this.title = value.title
        } else {
          this.$mesage(message)
        }
      })
    },
    showDia() {
      this.show = true
    },
    goFalse() {
      this.show = false
    },
    goOk() {
      this.show = false
    }
  }
}
</script>
  <style>
  .enterBodys img{
      width:100%;
  }
  .enterBodys p{
    color: #131295;
  }
  </style>
    <style lang="scss" scoped>
    /deep/ .el-dialog {
      background: linear-gradient(
        265deg,
        rgba(255, 255, 255, 0.6) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      background: url("../../../assets/images/1.png") no-repeat;
      background-size: 100% 100%;
      p span{
        color: rgb(19, 18, 149);
      }
      .headers {
        position: relative;
        width: 100%;
        height: 40px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, "PingFang SC";
        font-weight: 600;
        color: #131295;
        line-height: 40px;
        text-align: center;
        margin-bottom:10px;
        p{
          color: #131295;
        }
      }
    }
    .main {
      background: url("../../../assets/images/2.png") no-repeat;
      background-size: 100% 150%;
      height: 260px !important;
      min-height: 260px !important;
      overflow: auto !important;
      padding: 20px 35px;
      p *{
        font-size: 16px !important;
        font-family: PingFangSC-Semibold, "PingFang SC";
        font-weight: 600 !important;
        color: rgba(19, 18, 149, 0.8) !important;
      }
      .title2{
          font-family: 仿宋;
          font-size: 28px !important;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #131295;
          position: relative;
          top: -20px;
        margin: 0 10px;
    }
    }
    .main::-webkit-scrollbar-thumb {
      border-radius: 4px;
    }
    .main::-webkit-scrollbar-thumb {
      background-color: #D4D4D4;
    }
    .main::-webkit-scrollbar {
      height: 10px;
    }
    .el-dialog {
      height: 90vh;
      margin-top: 5vh;
      overflow: scroll;
    }
    /deep/ .el-dialog__footer {
      display: none;
    }
    .btnWrap {
      display: flex;
      // padding: 20px 20px;
    //   padding-bottom: 30px;
      padding-top: 30px;

      .nextStepBtn {
        // flex: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 0 auto;
        cursor: pointer;
      }
    }
    .btnWrap > div:first-child {
      margin-right: 20px;
      color: #fff;
      background-color: transparent;
      // border: 1px solid #979797;
    }
    .sureBtn {
      background-color: #2483ff;
      color: #fff;
    }
    </style>

